module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-wrapper"
  }, _vm._l((_vm.count), function(item, index) {
    return (!_vm.textOnly) ? _c('div', {
      key: item,
      staticClass: "timeline-item"
    }, [_vm._m(0, true), _vm._v(" "), (index < (_vm.count - 1)) ? _c('hr') : _vm._e()]) : _c('div', {
      staticClass: "timeline-item"
    }, [(!_vm.textArray.length) ? _c('span', [_c('p', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(_vm.textValue))])]) : _c('span', _vm._l((_vm.textArray), function(item) {
      return _c('p', {
        staticClass: "text-item"
      }, [_vm._v(_vm._s(item))])
    }), 0)])
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated-background"
  }, [_c('div', {
    staticClass: "background-masker header-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-first-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-second-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-second-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-third-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-third-end"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-966da568","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/ContentPlaceholder.vue
// module id = 3371
// module chunks = 3